import { useQuery } from "react-query";
import { getJSON } from "../../../../http";
import { dataSourcesKey, dataSourcesUrl } from "./datasources.constants";
import { DatasourcesResponse } from "./datasources.types";

export function useDataSourcesQuery() {
  const { isLoading, error, data } = useQuery(dataSourcesKey, () => getJSON<DatasourcesResponse>(dataSourcesUrl));
  return { isDataSourcesLoading: isLoading, dataSourcesError: error, dataSources: data };
}
